import { render, staticRenderFns } from "./manuscriptModal.vue?vue&type=template&id=83c16982"
import script from "./manuscriptModal.vue?vue&type=script&lang=js"
export * from "./manuscriptModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports